import React from 'react';

import { Portal } from 'src/HOC';

import Loader from './loader';

import './popup-loader.scss';

export interface IProps {
  visible: boolean;
}

const PopupLoader: React.FC<IProps> = ({ visible }): JSX.Element | null => {
  if (!visible) {
    return null;
  }

  return (
    <Portal>
      <div className="popup-loader">
        <Loader />
      </div>
    </Portal>
  );
};

export default PopupLoader;
